import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import { CopilotAction } from 'models/copilot/copilotAction';
import { TenantProcess } from 'models/copilot/tenantProcessStateBase';
import { CopilotPanelButton } from '../CopilotPanelButton';
import { isActionSelected, isProcessActionDisabled } from './copilotActionState';

interface ICopilotActionButtonsProps {
  actions: CopilotAction[];
  activeProcessId?: TenantProcess;
  compact?: boolean;
  disabled?: boolean;
  processSelectionRequired?: boolean;
  selectedRunningProcessId?: TenantProcess;
  suppressProcessStartIcon?: boolean;
  onActionClick: (item: CopilotAction) => void | Promise<void>;
}

export const CopilotActionButtons = (props: ICopilotActionButtonsProps) => {
  return (
    <IPStack tokens={globalStackTokensGapSmall}>
      {props.actions?.map((action) => {
        return (
          <IPStack.Item key={action.id}>
            <CopilotPanelButton
              action={action}
              compact={props.compact}
              disabled={
                action.disabled || props.disabled || isProcessActionDisabled(action, props.selectedRunningProcessId)
              }
              processSelectionRequired={props.processSelectionRequired}
              selected={isActionSelected(action, props.activeProcessId)}
              suppressProcessStartIcon={props.suppressProcessStartIcon}
              onActionClick={props.onActionClick}
            />
          </IPStack.Item>
        );
      })}
    </IPStack>
  );
};
